import { render } from "./ImageDescription.vue?vue&type=template&id=20f82dc2&scoped=true&ts=true"
import script from "./ImageDescription.vue?vue&type=script&lang=ts"
export * from "./ImageDescription.vue?vue&type=script&lang=ts"

import "./ImageDescription.vue?vue&type=style&index=0&id=20f82dc2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f82dc2"]])

export default __exports__